import { generateMeasuresFromDimensions } from './generate-measures.js';
import { seatApplicationStatusValueLabels, seatTermApplicationStatusValueLabels, } from './value-labels.js';
const aggregatableDimensions = {
    'seat_applications.days_in_pipeline': {
        aggregations: ['avg', 'max'],
        label: 'Days in Pipeline',
        type: 'number',
    },
    'seat_applications.email': {
        aggregations: ['countDistinct'],
        label: 'Email',
        type: 'string',
    },
};
export const seatApplicationsCube = {
    category: 'Applications',
    description: 'Individual seat applications with applicant details, status, and pipeline metrics.',
    label: 'Seat Applications',
    requiredModule: 'hasTenure',
    measures: {
        'seat_applications.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
    },
    dimensions: {
        ...aggregatableDimensions,
        'addresses.address_1': { label: 'Address 1', type: 'string' },
        'addresses.address_2': { label: 'Address 2', type: 'string' },
        'addresses.city': { label: 'City', type: 'string' },
        'addresses.postal_code': { label: 'Postal Code', type: 'string' },
        'addresses.state': { label: 'State', type: 'string' },
        'phones.number': { label: 'Phone Number', type: 'string' },
        'seat_applications.code': { label: 'Code', type: 'string' },
        'seat_applications.employer': { label: 'Employer', type: 'string' },
        'seat_applications.ethnicity': { label: 'Ethnicity', type: 'string' },
        'seat_applications.first_name': { label: 'First Name', type: 'string' },
        'seat_applications.is_gov_submitted': { label: 'Is Gov Submitted', type: 'boolean' },
        'seat_applications.last_name': { label: 'Last Name', type: 'string' },
        'seat_applications.latest_application_status': {
            label: 'Latest Application Status',
            type: 'string',
            valueLabels: seatTermApplicationStatusValueLabels,
        },
        'seat_applications.occupation': { label: 'Occupation', type: 'string' },
        'seat_applications.qualifications': { label: 'Qualifications', type: 'string' },
        'seat_applications.reason': { label: 'Reason', type: 'string' },
        'seat_applications.status': {
            label: 'Status',
            type: 'string',
            valueLabels: seatApplicationStatusValueLabels,
        },
        'seat_applications.total_applications': { label: 'Total Applications', type: 'number' },
    },
    timeDimensions: {
        'seat_applications.created_at': { label: 'Created At', type: 'date' },
        'seat_applications.first_applied_date': { label: 'First Applied Date', type: 'date' },
        'seat_applications.most_recent_application_date': {
            label: 'Most Recent Application Date',
            type: 'date',
        },
        'seat_applications.submitted_at': { label: 'Submitted At', type: 'date' },
        'seat_applications.updated_at': { label: 'Updated At', type: 'date' },
    },
};
